import script from "./AdminMonthlyStatsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMonthlyStatsModal.vue?vue&type=script&setup=true&lang=js"

import "./AdminMonthlyStatsModal.vue?vue&type=style&index=0&id=a0b964c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0b964c6"]])

export default __exports__